import { useLayoutEffect, useRef, useState } from "react";

// Jadval ostida pagination (~44px) va sahifa pastki paddingi uchun joy
const BOTTOM_RESERVE = 84;
const MIN_HEIGHT = 240;

// Jadval balandligi = ekranning qolgan qismi: sahifa scroll bo'lmaydi, faqat jadval ichi scroll bo'ladi
export default function useFillViewportHeight(deps = [], bottomReserve = BOTTOM_RESERVE) {
    const ref = useRef(null);
    const [height, setHeight] = useState(null);

    useLayoutEffect(() => {
        const update = () => {
            const el = ref.current;
            if (!el) return;
            const top = el.getBoundingClientRect().top + window.scrollY;
            setHeight(Math.max(MIN_HEIGHT, Math.floor(window.innerHeight - top - bottomReserve)));
        };
        update();
        window.addEventListener("resize", update);
        // Tepadagi bloklar (statistika kartochkalari va h.k.) keyinroq yuklanib, joyni o'zgartirishi mumkin
        const observer = typeof ResizeObserver !== "undefined" ? new ResizeObserver(update) : null;
        observer?.observe(document.body);
        return () => {
            window.removeEventListener("resize", update);
            observer?.disconnect();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);

    return [ref, height];
}
